import styled from "styled-components/macro";
import {InfoCircle} from '@styled-icons/boxicons-regular'

const InformationIcon = styled(InfoCircle)`
    color: #666;
    width: 18px;
    height: 18px;
    margin-top: 8px;
    margin-left: 18px;
    margin-bottom: 5px;
    &:hover {
        cursor: pointer;
        color: #64cdef;
    }
`
export default InformationIcon